// extracted by mini-css-extract-plugin
export default {"activeItem":"SelectBox_activeItem__Tb8Wa","item":"SelectBox_item__l3bUI","icon":"SelectBox_icon__KzEla"};